import type { Ref } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export default function getTranslationKeys(): Ref<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      mirrors: {
        mirrors_list_js: {
          edit_tracking: {
            header: 'JS_EDIT_HEADER',
            save: 'JS_EDIT_SAVE',
            back: 'JS_EDIT_BACK',
            form: {
              link: 'JS_EDIT_FORM_LINK',
              priority: 'JS_EDIT_FORM_PRIORITY',
              enabled: 'JS_EDIT_FORM_ENABLED',
            },
          },
        },
        mirrors_list_no_js: {
          edit_tracking: {
            header: 'NO_JS_EDIT_HEADER',
            save: 'NO_JS_EDIT_SAVE',
            back: 'NO_JS_EDIT_BACK',
            form: {
              link: 'NO_JS_EDIT_FORM_LINK',
              priority: 'NO_JS_EDIT_FORM_PRIORITY',
              enabled: 'NO_JS_EDIT_FORM_ENABLED',
            },
          },
        },
      },
    },
  }));
}
